import React from 'react';
import { Col, Form } from 'antd';
import { I18n } from '@aws-amplify/core';

import { useLines } from '@/hooks/v1';
import type { InputDefaultProps } from '../../../types';
import { FormItem } from '@/components/ui/Inputs/FormItem';
import { LineSelect } from '@/components/ui/Inputs/LineSelect';

const { useFormInstance, useWatch } = Form;

export function Lines({
	fieldName,
	fontSize = '1rem',
	disabled = false,
	isRequired = false
}: Readonly<InputDefaultProps>) {
	const form = useFormInstance();

	const organizationId = useWatch([fieldName, 'organization_id'], form);
	const companyId = useWatch([fieldName, 'company_id'], form);
	const sectorId = useWatch([fieldName, 'sector_id'], form);
	const lineId = useWatch([fieldName, 'line_id'], form);

	const {
		data: lines,
		isFetching,
		isLoading,
		isError
	} = useLines({
		organization_id: organizationId,
		company_id: companyId,
		sector_id: sectorId
	});

	function handleSelectLine(id: string): void {
		form.setFieldValue([fieldName, 'line_id'], id);
		form.setFieldValue([fieldName, 'workstation_id'], undefined);
	}

	function handleClearLines(): void {
		form.setFieldValue([fieldName, 'line_id'], undefined);
		form.setFieldValue([fieldName, 'workstation_id'], undefined);
	}

	return (
		<Col xs={24}>
			<FormItem
				fontSize={fontSize}
				isRequired={isRequired}
				title={I18n.get('Line')}
				namePath={[fieldName, 'line_id']}
				errorMessage={I18n.get('Select a line')}
			>
				<LineSelect
					size="large"
					lines={lines}
					lineId={lineId}
					sectorId={sectorId}
					loading={isFetching}
					fieldName={[fieldName, 'line_id']}
					handleSelectLine={handleSelectLine}
					handleClearLines={handleClearLines}
					disabled={isLoading || isFetching || isError || !sectorId || disabled}
				/>
			</FormItem>
		</Col>
	);
}
